import React from 'react';
import { PageRenderProps, GamePageRegistry } from '@mental-mint/shared-ui';
import { CraftegoryPageId } from './CraftegoryPageTypes';
import { PagePlay } from './PagePlay/PagePlay';
import { PagePuzzleIntro } from './PagePuzzleIntro/PagePuzzleIntro';
import { PageVictory } from './PageVictory/PageVictory';

export const craftegoryPageRegistry: GamePageRegistry = {
  getPageRenderers: () => ({
    [CraftegoryPageId.Play]: ({ navigateToPage }: PageRenderProps) => (
      <PagePlay navigateToPage={navigateToPage} />
    ),
    [CraftegoryPageId.PuzzleIntro]: ({ onRequestClose }: PageRenderProps) => (
      <PagePuzzleIntro onRequestClose={onRequestClose} />
    ),
    [CraftegoryPageId.Victory]: ({ onRequestClose, navigationProps }: PageRenderProps) => (
      <PageVictory
        onRequestClose={onRequestClose}
        combinationsCount={navigationProps?.combinationsCount ?? 0}
        themeName={navigationProps?.themeName ?? ''}
        totalTerms={navigationProps?.totalTerms ?? 0}
      />
    ),
  }),
};
